export default __webpack_public_path__ + "static/media/logo-cc.3633e4d6.svg";